import { useCallback, useSyncExternalStore } from 'react';
import { getStore, newConditionId } from '../lib/filterStore.js';

// Le store lui-même (sans React) vit dans lib/filterStore.js : réexporté ici
// pour ne pas changer les imports existants.
export {
  getFilterStore,
  applySessionFilter,
  resetAllFilters,
  toFilterQuery,
  hasNonSelfFilter,
} from '../lib/filterStore.js';

/**
 * Hook principal — retourne l'état + les actions pour un scope donné.
 *
 *   const { conditions, addCondition, updateCondition, removeCondition,
 *           clearAll, replaceConditions } = useFilterStore('schedule');
 */
export function useFilterStore(scope) {
  const store = getStore(scope);
  const conditions = useSyncExternalStore(
    store.subscribe,
    store.getSnapshot,
    store.getSnapshot,
  );

  const addCondition = useCallback(
    (cond) => {
      store.setState([...store.getSnapshot(), { ...cond, id: newConditionId() }]);
    },
    [store],
  );

  const updateCondition = useCallback(
    (id, patch) => {
      store.setState(
        store.getSnapshot().map((c) => (c.id === id ? { ...c, ...patch } : c)),
      );
    },
    [store],
  );

  const removeCondition = useCallback(
    (id) => {
      store.setState(store.getSnapshot().filter((c) => c.id !== id));
    },
    [store],
  );

  const clearAll = useCallback(() => {
    store.setState([]);
  }, [store]);

  const replaceConditions = useCallback(
    (next) => {
      store.setState(next ?? []);
    },
    [store],
  );

  return {
    conditions,
    addCondition,
    updateCondition,
    removeCondition,
    clearAll,
    replaceConditions,
  };
}
